import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import AppInstallNudge from '../../../src/components/BabyNameFinder/AppInstallNudge/AppInstallNudge';
import BabyNamesArticle from '../../../src/components/BabyNameFinder/BabyNamesArticle';
import BabyNamesHeadElements from '../../../src/components/BabyNameFinder/BabyNamesHeadElements';
import BreadCrumbs from '../../../src/components/BabyNameFinder/BreadCrumbs';
import {
  BabyFinderContainer,
  Wrapper,
} from '../../../src/components/BabyNameFinder/FinderDetailPage/AboutNameFinder/styled';
import BabyNameTopBanner from '../../../src/components/BabyNameFinder/FinderDetailPage/BabyNameTopBanner/BabyNameTopBanner';
import ExploreNames from '../../../src/components/BabyNameFinder/FinderDetailPage/ExploreNames';
import UniqueBabyNames from '../../../src/components/BabyNameFinder/FinderDetailPage/UniqueBabyNames';
import {
  servedSectionEvent,
  viewedScreenEvent,
} from '../../../src/components/BabyNameFinder/instrumentation/instrumentation';
import MostPopularName from '../../../src/components/BabyNameFinder/MostPopularName/MostPopularName';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import { babyNames } from '../../../src/datafetchers/BabyNameFinderPage';
import { getFeedsData } from '../../../src/datafetchers/HomePage';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import { SVGSourceBabyNames } from '../../../src/Svg/BabyNamesPage';
import {
  androidDisablePullRefresh,
  checkAndroidStopLoader,
  enableAndroidBack,
  hideAndroidBottomBar,
  hideAndroidTopBar,
} from '../../../src/Utils/androidUtils';
import {
  getFilteredArticleData,
  getFilteredData,
} from '../../../src/Utils/commonUtils';
import {
  getFilteredCategoryContent,
  isAndroidAppUser,
} from '../../../src/Utils/helper';
import { iosHideTopBar, isIOSAppUser } from '../../../src/Utils/IosUtils';
import { storeDataFetcher } from '../../../src/datafetchers/Store';

export async function getStaticProps() {
  const params = {
    gender: 'Boy',
    mostViewed: '1',
    limit: '18',
    page: '1',
  };
  const babyNamesBoy = await babyNames(params);
  params['gender'] = 'Girl';
  const babyNamesGirl = await babyNames(params);
  const articleParams = {
    tag: 574,
  };
  const articleData = await getFeedsData(articleParams);
  const babyNamesGenderKeys = ['id', 'name', 'meaning'];
  const babyNamesBoyData = [];
  babyNamesBoy?.data?.map((element) => {
    const obj = getFilteredData(element, babyNamesGenderKeys);
    babyNamesBoyData.push(obj);
  });
  const babyNamesGirlData = [];
  babyNamesGirl?.data?.map((element) => {
    const obj = getFilteredData(element, babyNamesGenderKeys);
    babyNamesGirlData.push(obj);
  });
  const data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  return {
    props: {
      babyNamesBoy: babyNamesBoyData,
      babyNamesGirl: babyNamesGirlData,
      articleData:
        getFilteredArticleData(articleData?.data?.posts?.items) || null,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
    },
    revalidate: 60,
  };
}

export default function BabyNamesComponent(props) {
  const { babyNamesBoy, babyNamesGirl, articleData, categoryData } = props;
  const [hideHamIcon, setShowHamIcon] = useState(false);
  const metaTitle = `Get Baby Names and Meaning from More Than 100k Names to Choose From!`;
  const metaDescription = `It's worth taking the time and putting in the effort to find that perfect name for your baby. Choose the perfect name for your little one from from Mylos Baby Name Finder.`;

  useEffect(() => {
    if (isAndroidAppUser()) {
      hideAndroidTopBar();
      enableAndroidBack(true);
      hideAndroidBottomBar();
      androidDisablePullRefresh();
      checkAndroidStopLoader();
      setShowHamIcon(true);
    }
    if (isIOSAppUser()) {
      iosHideTopBar();
      setShowHamIcon(true);
    }
    //viewed Event
    viewedScreenEvent(true);
    // served section event
    servedSectionEvent(true, 'View My Saved Names');
    servedSectionEvent(true, 'Browse by Letter');
    servedSectionEvent(true, 'Search By');
    servedSectionEvent(true, 'BABY NAMES BY RELIGION');
  }, []);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
        />
      </Head>
      <GlobalStyle />
      <NewHeader
        hideMobileSearch={true}
        hideLogin={true}
        hideHamIcon={hideHamIcon}
        categoryData={categoryData}
        nostrip={true}
      />
      <AppInstallNudge />
      <SVGSourceBabyNames />
      <BabyNamesHeadElements
        metaTitle={metaTitle}
        metaDescription={metaDescription}
      />
      <Wrapper>
        {/* <AboutNameFinder /> */}
        {!hideHamIcon && <BreadCrumbs />}

        <BabyNameTopBanner />
        <BabyFinderContainer>
          <ExploreNames />
          {!hideHamIcon && <BabyNamesArticle articleData={articleData} />}
          <UniqueBabyNames
            babyNamesBoy={babyNamesBoy}
            babyNamesGirl={babyNamesGirl}
            home={true}
          />
          <MostPopularName />
        </BabyFinderContainer>
      </Wrapper>
      {!hideHamIcon && <NewFooter />}
    </>
  );
}
